/**
 * Enables the usage of the Terms call from core+
 * This pulls terms from MC Terms for opt-in requirements
 */
export const ENABLE_MC_TERMS = 'NHCGUEST-8280';
